export default {
  drafts: {
    title: 'Facturas sin emitir',
    edit: 'Edición',
    view: 'Ver Factura',
    duplicate: 'Duplicar',
    issue: 'Emitir',
    sendProForm: 'Enviar Pro Forma',
    history: 'Histórico',
    deleteTitle: 'Eliminar borrador seleccionado',
    deleteConfirm: '¿Está seguro que desea eliminar el borrador seleccionado?',
    download: 'Descargar',
    // requestText: 'Se ha solicitado la emisión de las facturas. En breve recibirá la notificación por correo electrónico con el resultado de la emisión. Las facturas emitidas se almacenan en el menú Facturas a cobrar de Facturas emitidas. Desde esa pantalla podrá ver el detalle de una factura, gestionar su cobro o descargarla en distintos formatos'
    requestText: 'Se ha solicitado la emisión de las facturas. Puede consultar las facturas emitidas en el menú Emitidas y recibidas, tanto como proveedor como pagador. Desde esa pantalla podrá ver el detalle de una factura, gestionar su cobro o descargarla en distintos formatos'
  },
  newInvoice: {
    dataTitle: 'Datos generales',
    detailsTitle: 'Detalles de la factura',
    paymentTitle: 'Descuentos y formas de pago',
    summaryTitle: 'Resumen',
    stepBack: 'Ir a paso anterior',
    saveAsDraft: 'Guardar como borrador',
    factoringTitle: 'Datos de factoring',
    validationError: 'Ha ocurrido un error de validación de la factura',
    factoring: {
      messageOk: 'Se ha solicitado la financiación correctamente',
      messageKo: 'No se ha podido enviar la solicitud de financiación, vuelve a intentarlo más tarde desde la pestaña "Financiación"'
    },
    alertCaixaThirdPartyClientWithLink: 'Las facturas dirigidas a CaixaBank no admiten la creación de suplidos',
    alertTxtMortgageExpenses: 'Para facturar al departamento Gastos Hipotecarios, debe hacerlo desde el Portal de Proveedores de CaixaBank',
    alertBFA: `Con motivo de la fusión entre Bankia, S.A. y CaixaBank, S.A. operada el pasado 26 de marzo, BFA ha pasado a asumir directamente la gestión de los todos los servicios propios de la 
    ejecución de su actividad de manera autónoma e independiente.<br/><br/>Les anticipamos el correo electrónico creado para la interlocución durante la prestación de sus servicios y que les 
    rogamos encarecidamente que, en adelante, utilicen como principal medio de comunicación entre las partes: <a href="mailto:informacion@bfa.com.es">informacion@bfa.com.es</a><br/><br/> En aquellos 
    casos excepcionales en los que lo anterior no resultase posible, podrán dirigirse asimismo la sede social de BFA:<br/><div style="text-align:center"><span>BFA TENEDORA DE ACCIONES S.A.<br/>
    AVENIDA GENERAL PERON, 38<br/>EDIFICIO MASTER II<br/>28020 MADRID</span></div><br/>Agradecemos de antemano su colaboración y quedamos a su disposición para cualquier aclaración que se considere necesaria.`,
    alertPension: 'Para facturar a Bankia Pensiones, debe hacerlo desde el Portal de Proveedores de CaixaBank'
  },
  autodrafts: {
    title: 'Autofacturas sin emitir',
    edit: 'Editar Autofactura'
  },
  thirdParty: {
    title: 'Suplidos y terceros sin emitir'
  },
  ok: '<span style="font-size: 20px;">Para finalizar el proceso de alta, le hemos enviado un <span style="font-weight: bold">email a {0}</span> para que active su cuenta.</span>'
}
